import apiInstannce, { consoleAxiosInstance, notificationAxiosInstance, aiApiInstance } from "./httpInterCeptors";

// GET API Call
export const globalGetService = (url, params) => {
  return new Promise(
    function (resolve, reject) {
      apiInstannce({ method: 'GET', url: url, data: params })
        .then(response => {
          resolve(response);
        })
        .catch(error => reject(error))
    }
  )
}
export const globalGetParamsService = (url, params) => {
  return new Promise(
    function (resolve, reject) {
      apiInstannce({ method: 'GET', url: url, params: params })
        .then(response => {
          resolve(response);
        })
        .catch(error => reject(error))
    }
  )
}
export const globalGetAiService =(url, params)=>{
  return new Promise(
    function (resolve, reject){
      aiApiInstance({method:'GET', url:url, params:params})
      .then(response=>{
        resolve(response)
      })
      .catch(error => reject(error))
    }
  )
}
export const globalPostAiService = (url, data) => {
  return new Promise(
    function (resolve, reject){
      aiApiInstance({method:'POST', url:url, data:data})
      .then(response=>{
        resolve(response)
      })
      .catch(error => reject(error))
    }
  )
}
export const globalPutAiService = (url, data) => {
  return new Promise(
    function (resolve, reject){
      aiApiInstance({method:'PUT', url:url, data:data})
      .then(response=>{
        resolve(response)
      })
      .catch(error => reject(error))
    }
  )
}

export const globalPostFileUploadService = (url, data) => {
    return new Promise((resolve, reject) => {
    apiInstannce({
      method: "POST",
      url: url,
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};


export const globalPostFileUpdateService = (url, file, onProgress) => {
  return apiInstannce({
    method: "PUT",
    url: url,
    data: file,
    headers: {
      "Authorization": undefined,
      "Content-Type": file?.type || "application/octet-stream",
    },
    transformRequest: [(data, headers) => {
      delete headers.common?.Authorization;
      delete headers.Authorization;
      return data;
    }],
    onUploadProgress: (event) => {
      if (event?.lengthComputable && typeof onProgress === "function") {
        const percent = Math.round((event.loaded / event.total) * 100);
        onProgress(percent); 
      }
    }
  });
};

// POST API Call
export const globalPostService = (url, data) => {
  return new Promise((resolve, reject) => {
    apiInstannce({
      method: "POST",
      url: url,
      data: data,
    })
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};


// PUT API Call
export const globalPutService = (url, data) => {
  return new Promise(function (resolve, reject) {
    apiInstannce({
      method: "PUT",
      url: url,
      data: data,
    }) 
    .then((response) => resolve(response))
    .catch((error) => reject(error));
  });
};


// DELETE API Call
export const globalDeleteService = (url, data) => {
  return new Promise(function (resolve, reject) {
    apiInstannce({
      method: "DELETE",
      url: url,
      data: data,
    })
    .then((response) => resolve(response))
    .catch((error) => reject(error));
  });
};

// GET API Call
export const globalBetaGetService = (url, params) => {
  return new Promise(
    function (resolve, reject) {
      notificationAxiosInstance({ method: 'GET', url: url, data: params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
        })
    }
  )
}

export const globalBetaPostService = (url, data,header) => {
  return new Promise((resolve, reject) => {
    notificationAxiosInstance({
      method: "POST",
      url: url,
      data: data,
      headers:header
    })
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};


// New console API services using consoleAxiosInstance
// GET API Call for console
export const consoleGetService = (url, params) => {
  return new Promise(function (resolve, reject) {
    consoleAxiosInstance({
      method: "GET",
      url: url,
      params: params,
    }).then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    });
  });
};

// POST API Call for console
export const consolePostService = (url, data) => {
  return new Promise(function (resolve, reject) {
    consoleAxiosInstance({
      method: "POST",
      url: url,
      data: data,
    }).then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    });
  });
};

// PUT API Call for console
export const consolePutService = (url, data) => {
  return new Promise(function (resolve, reject) {
    consoleAxiosInstance({
      method: "PUT",
      url: url,
      data: data,
    }).then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    });
  });
};

// DELETE API Call for console
export const consoleDeleteService = (url, data) => {
  return new Promise(function (resolve, reject) {
    consoleAxiosInstance({
      method: "DELETE",
      url: url,
      data: data,
    }).then((response) => {
      resolve(response);
    }).catch((error) => {
      reject(error);
    });
  });
};

// File/Attachment Post API
export const globalFileUploadService = (url, data, config, params) => {
  return new Promise(
    function (resolve, reject) {
      apiInstannce({
        method: 'POST',
        url: url,
        data: data,
        params: params && Object.keys(params).length ? { ...params, timestamp: new Date().getTime() } : { timestamp: new Date().getTime() },
        config: config
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(error => {
          reject(error)
        })
    }
  )
}

// File/Attachment Put API
export const globalFileUploadPutService = (url, data, config, params) => {
  return new Promise(
    function (resolve, reject) {
      apiInstannce({
        method: 'PUT',
        url: url,
        data: data,
        params: params && Object.keys(params).length ? { ...params, timestamp: new Date().getTime() } : { timestamp: new Date().getTime() },
        config: config
      })
        .then(function (response) {
          resolve(response);
        })
        .catch(error => {
          reject(error)
        })
    }
  )
}

export const globalExportService = (url, params) => {
  return new Promise(function (resolve, reject) {
    apiInstannce({
      method: 'GET',
      url: url,
      responseType: 'blob',
      params: params
    })
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
}


export const globalPostExportService = (url, data) => {
  return new Promise((resolve, reject) => {
    apiInstannce({
      method: "POST",
      url: url,
      responseType: 'blob',
      data: data,
    })
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};